import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';
import { serverError } from 'src/utils';
import { parseRequestType, parseRequestType4Up } from 'api/getRequestType';

const mutation = gql`
mutation CreateRequestType($input: CreateRequestTypeInput!) {
  createRequestType(input: $input) {
    id
    name
    description
    defaultType
    active
    system
    keywords {
      token
    }
    teams {
      id
      name
    }
    allTeamsOn
  }
}`;

const fieldsName = {
  name: 'T_SKILL',
  description: 'T_REQUEST_TYPE',
  keywords: 'T_KEYWORDS',
};

function onParseErrors(item) {
  return serverError.interpolation(item, fieldsName);
}

function createRequestType(item) {
  const arg = parseRequestType4Up(item);
  return apollo.client.mutate({
    mutation,
    variables: {
      input: {
        ...arg,
      },
    },
  }).then((res) => parseRequestType(res.data.createRequestType))
    .catch((err) => {
      if (err.graphQLErrors.length) {
        const errors = err.graphQLErrors[0].error.payload;
        throw errors.map(onParseErrors);
      } else {
        throw err;
      }
    });
}

export default createRequestType;
